'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TooltipCompareIcon = function TooltipCompareIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 17.993999481201172 16' }, props),
        _react2.default.createElement('path', { d: 'M2.998 1.019V1L.006 4.008 3 7h15V1.019H2.998zm0 7.988v-.015L.006 11.994 3 15h15V9l-15.002.007z' })
    );
};

exports.default = TooltipCompareIcon;